import { render, staticRenderFns } from "./app-message.vue?vue&type=template&id=0a2fc35c&scoped=true"
import script from "./app-message.vue?vue&type=script&lang=js"
export * from "./app-message.vue?vue&type=script&lang=js"
import style0 from "./app-message.vue?vue&type=style&index=0&id=0a2fc35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2fc35c",
  null
  
)

export default component.exports